var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.47768H0.5C0.223858 3.47768 0 3.25292 0 2.97566C0 2.6984 0.223858 2.47363 0.5 2.47363H15.5C15.7761 2.47363 16 2.6984 16 2.97566C16 3.25292 15.7761 3.47768 15.5 3.47768Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.49388H0.5C0.223858 7.49388 0 7.26911 0 6.99185C0 6.71459 0.223858 6.48983 0.5 6.48983H5.5C5.77614 6.48983 6 6.71459 6 6.99185C6 7.26911 5.77614 7.49388 5.5 7.49388Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.5101H5.5C5.77614 11.5101 6 11.2853 6 11.008C6 10.7308 5.77614 10.506 5.5 10.506H0.5C0.223858 10.506 0 10.7308 0 11.008C0 11.2853 0.223858 11.5101 0.5 11.5101Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.5263C0.223858 15.5263 0 15.3015 0 15.0242C0 14.747 0.223858 14.5222 0.5 14.5222H15.5C15.7761 14.5222 16 14.747 16 15.0242C16 15.3015 15.7761 15.5263 15.5 15.5263H0.5Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4454 10.2432C13.7946 9.75083 14 9.14846 14 8.49792C14 6.83436 12.6569 5.48578 11 5.48578C9.34315 5.48578 8 6.83436 8 8.49792C8 10.1615 9.34315 11.5101 11 11.5101C11.6479 11.5101 12.2479 11.3038 12.7383 10.9532L14.6464 12.8691C14.8417 13.0652 15.1583 13.0652 15.3536 12.8691C15.5488 12.673 15.5488 12.3552 15.3536 12.1591L13.4454 10.2432ZM11 10.506C9.89543 10.506 9 9.60697 9 8.49792C9 7.38888 9.89543 6.48983 11 6.48983C12.1046 6.48983 13 7.38888 13 8.49792C13 9.60697 12.1046 10.506 11 10.506Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.e5517c052644b875870de9eef8459537.svg";
export { ForwardRef as ReactComponent };